import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { cn } from '@/shared/lib/utils'
import { Logo } from '@/shared/components/logo'
import { useSmoothScroll } from '../hooks/use-smooth-scroll'

/**
 * Landing page footer
 * Implementation: LAND2-007
 */
export function Footer() {
  const { t } = useTranslation()
  const { scrollToHowItWorks, scrollToPricing, scrollToFaq } = useSmoothScroll()

  const linkClasses = cn(
    'text-sm text-white/60 transition-colors duration-200',
    'hover:text-accent'
  )

  return (
    <footer className="bg-[#0F172A] py-12 sm:py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Main content */}
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Logo & Tagline */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white">
                <Logo className="h-5 w-5 text-primary" />
              </div>
              <span className="text-xl font-bold text-white">HeyNicolai</span>
            </div>
            <p className="mt-2 text-sm text-white/60">
              {t('landing.footer.tagline')}
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-sm font-semibold text-white">
              {t('landing.footer.product')}
            </h3>
            <ul className="mt-4 space-y-3">
              <li>
                <button onClick={scrollToHowItWorks} className={linkClasses}>
                  {t('landing.footer.productLinks.howItWorks')}
                </button>
              </li>
              <li>
                <button onClick={scrollToPricing} className={linkClasses}>
                  {t('landing.footer.productLinks.pricing')}
                </button>
              </li>
              <li>
                <button onClick={scrollToFaq} className={linkClasses}>
                  {t('landing.footer.productLinks.faq')}
                </button>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-sm font-semibold text-white">
              {t('landing.footer.legal')}
            </h3>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/terms" className={linkClasses}>
                  {t('landing.footer.legalLinks.terms')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className={linkClasses}>
                  {t('landing.footer.legalLinks.privacy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-sm font-semibold text-white">
              {t('landing.footer.support')}
            </h3>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href="https://x.com/NicolAI_app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClasses}
                >
                  {t('landing.footer.supportLinks.twitter')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-12 border-t border-white/10 pt-8">
          {/* Copyright */}
          <p className="text-center text-sm text-white/40">
            {t('landing.footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  )
}
